// Shared campaign constants: goals Meta can run, button codes, statuses and money maths.

export const GOALS = [
  { key: 'website', label: 'Get website visits', help: 'People tap through to your website or store.' },
  { key: 'calls', label: 'Get calls', help: 'People call your phone from the ad.' },
  { key: 'whatsapp', label: 'Get WhatsApp messages', help: 'People start a WhatsApp chat with you.' },
  { key: 'leads', label: 'Get leads', help: 'People leave their name and number in a quick form.' },
  { key: 'engagement', label: 'Get likes, comments & shares', help: 'More people notice and interact with your post. Great for getting known, but it doesn’t directly bring sales.' },
];

export const goalLabel = (key) => GOALS.find(g => g.key === key)?.label || key || '';

export const CTA_LABELS = {
  LEARN_MORE: 'Learn More', SHOP_NOW: 'Shop Now', SIGN_UP: 'Sign Up', CONTACT_US: 'Contact Us',
  BOOK_TRAVEL: 'Book Now', ORDER_NOW: 'Order Now', GET_OFFER: 'Get Offer', CALL_NOW: 'Call Now',
  WHATSAPP_MESSAGE: 'Send Message', GET_QUOTE: 'Get Quote', APPLY_NOW: 'Apply Now', SUBSCRIBE: 'Subscribe',
  NO_BUTTON: 'No button',
};

export const ALLOWED_CTAS = {
  website: ['LEARN_MORE', 'SHOP_NOW', 'SIGN_UP', 'CONTACT_US', 'BOOK_TRAVEL', 'ORDER_NOW', 'GET_OFFER'],
  calls: ['CALL_NOW'],
  whatsapp: ['WHATSAPP_MESSAGE'],
  leads: ['SIGN_UP', 'LEARN_MORE', 'GET_QUOTE', 'CONTACT_US', 'APPLY_NOW', 'SUBSCRIBE'],
  engagement: ['NO_BUTTON'],
};

export const ctaLabel = (code) => CTA_LABELS[code] || code || 'Learn More';

// Where to come back to after connecting or making a Facebook Page (a path; survives Facebook's login redirect).
export const RETURN_AD_KEY = 'rayogent-return-ad';
// An ad not saved yet (the chat, the plan and the wizard), kept while the owner goes off to make a Page.
export const AD_IN_PROGRESS_KEY = 'rayogent-ad-in-progress';

export const LIMITS = { headline: 40, primary_text: 125, description: 30 };

export const STATUS = {
  draft: { label: 'Draft', color: 'bg-zinc-500/10 text-muted-foreground border-zinc-500/30' },
  generating: { label: 'Generating', color: 'bg-brand/10 text-brand-strong border-ink/30' },
  ai_question: { label: 'Needs your answer', color: 'bg-brand/10 text-brand-strong border-ink/30' },
  review: { label: 'Ready to review', color: 'bg-blue-500/10 text-blue-700 dark:text-blue-400 border-blue-500/30' },
  launching: { label: 'Launching', color: 'bg-brand/10 text-brand-strong border-ink/30' },
  pending_review: { label: 'Quick check by our team', color: 'bg-amber-500/10 text-amber-700 dark:text-amber-400 border-amber-500/30' },
  queued: { label: 'Sending to Meta', color: 'bg-brand/10 text-brand-strong border-ink/30' },
  creating: { label: 'Sending to Meta', color: 'bg-brand/10 text-brand-strong border-ink/30' },
  in_meta_review: { label: 'Meta reviewing', color: 'bg-blue-500/10 text-blue-700 dark:text-blue-400 border-blue-500/30' },
  live: { label: 'LIVE', color: 'bg-money-soft text-money border-money/40 pulse-live' },
  paused: { label: 'Paused', color: 'bg-amber-500/10 text-amber-700 dark:text-amber-400 border-amber-500/30' },
  ended: { label: 'Ended', color: 'bg-zinc-500/10 text-muted-foreground border-zinc-500/30' },
  rejected: { label: 'Not approved', color: 'bg-red-500/10 text-red-700 dark:text-red-400 border-red-500/30' },
  cancelled: { label: 'Cancelled', color: 'bg-zinc-500/10 text-muted-foreground border-zinc-500/30' },
};

export const statusOf = (s) => STATUS[s] || STATUS.draft;
export const ACTIVE_STATUSES = ['queued', 'creating', 'in_meta_review', 'live', 'paused'];
export const DRAFT_STATUSES = ['draft', 'generating', 'ai_question', 'review'];
// Customers can delete drafts and finished ads (must match the backend's DELETABLE).
export const DELETABLE_STATUSES = ['draft', 'ai_question', 'review', 'ended', 'rejected', 'cancelled'];

// Must match the backend exactly: whole paise, rounded half up.
const percent = (amount, pct) => Math.floor((amount * pct + 50) / 100);
export function costBreakdown(spend) {
  const fee = percent(spend, 15);
  const gst = percent(fee, 18);
  return { spend, fee, gst, total: spend + fee + gst };
}
